import { z } from 'zod';
import { carNoValPartial, egPhone, passwordRegex } from '../utils/util';

// Zod 스키마 정의
export const forgotIdSchema = z.object({
  phone: z
    .string()
    .min(10, { message: '휴대폰 번호는 최소 10자리입니다.' })
    .max(13, { message: '최대 11자까지 입력 가능합니다.' }),
  authCode: z.string().length(6, { message: '인증 번호는 6자리여야 합니다.' }),
});

// Zod 스키마 정의
export const passwordChangeSchema = z
  .object({
    password: z
      .string()
      .min(8, { message: '비밀번호는 최소 8자 이상이어야 합니다.' }),
    passwordComfirm: z
      .string()
      .min(8, { message: '비밀번호 확인을 입력해주세요.' }),
  })
  .refine((data) => data.password === data.passwordComfirm, {
    path: ['passwordComfirm'],
    message: '비밀번호가 일치하지 않습니다.',
  });

export const passwordAuthSchema = z.object({
  passid: z.string().nonempty({ message: '아이디를 입력해주세요.' }),
  phone: z
    .string()
    .min(10, { message: '휴대폰 번호는 10자리 이상이어야 합니다.' }),
  authCode: z.string().length(6, { message: '인증 번호는 6자리여야 합니다.' }),
});
